import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { computed, observable } from 'mobx';
import { WordStore, SynonymAssociationStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import { Link } from 'react-router';
import DeleteButton from 'components/button/delete_button';
import CheckIfTrue from 'components/check_if_true';
import Text from 'components/text';
import SynonymsEditModal from './synonyms_edit_modal';
import autobind from 'autobind-decorator';

const Wrapper = styled.div`
  .synonyms-table {
    width: 100%;
    margin-top: 10px;
  }
`;

@observer
class SynonymsEdit extends React.Component {
  @observable showEditSynonyms = false;

  @autobind afterChange() {
    if (this.props.afterChange) {
      this.props.afterChange();
    }
  }

  @computed get word() {
    return this.props.word || WordStore.showData;
  }

  @computed get synonymAssociations() {
    return this.word.synonymAssociations || [];
  }

  @computed get hasSynonyms() {
    return isPresent(this.synonymAssociations) && this.synonymAssociations.filter(item => !item.simple).length > 0;
  }

  @autobind deleteSynonymAssociation(synonymAssociationId) {
    SynonymAssociationStore.destroy({ids: {synonymAssociationId}}, this.afterChange);
  }

  @autobind toggleShowAddSynonyms() {
    this.showEditSynonyms = !this.showEditSynonyms;
  }

  render() {
    if (!this.word.root || !this.word.wordType?.showInVocabTrainer) {
      return null;
    }

    const nonSimpleSynonyms = this.synonymAssociations.filter(item => !item.simple);

    return (
      <Wrapper>
        {
          this.showEditSynonyms &&
            <SynonymsEditModal
              word={this.word}
              onClose={() => this.showEditSynonyms = false}
              afterChange={this.afterChange}
              meaning={this.props.meaning}
            />
        }
        <div className='row'>
          <div className='col-xs-12'>
            <fieldset>
              <legend>Synonyms</legend>
              <table className='table-wrapper synonyms-table'>
                <thead>
                  <tr>
                    <th width='20'></th>
                    <th>Target</th>
                    <th>Sources</th>
                    <th>Similarity</th>
                    <th>Sentences</th>
                    <th>Word type</th>
                    <th>In Meaning</th>
                    <th>Public</th>
                    <th width='20'></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    nonSimpleSynonyms.map(item => {
                      return (
                        <tr key={item.id}>
                          <td>
                            <Link
                              to={{ name: 'builder.words.edit', params: { wordId: item.synonym.id } }}
                              className='on-click'
                            >
                              <i className='fa fa-chevron-right fa-block' />
                            </Link>
                          </td>
                          <td>
                            <div className='text'>
                              <Link
                                to={{name: 'builder.words.edit', params: {wordId: item.synonym.id}}}
                                className='underline'
                              >
                                {item.synonym.targetTextWithDefiniteArticle}
                                {item.plural && <span> (plur)</span>}
                                {item.isNoun && !item.plural && <span> (sing)</span>}
                              </Link>
                            </div>
                          </td>
                          <td>
                            <div className='text'>
                              <i>{item.synonym.sourceList}</i>
                            </div>
                          </td>
                          <td>
                            <div className='text'>
                              { item.similarity?.toLocaleString('en', {style: 'percent', maximumFractionDigits: 2}) }
                            </div>
                          </td>
                          <td>
                            <div className='text'>
                              { item.synonym.sentencesCount }
                            </div>
                          </td>
                          <td>
                            <div className='text'>
                              { item.synonym.wordTypeName }
                            </div>
                          </td>
                          <td>
                            <CheckIfTrue
                              circle
                              value={item.meaningId}
                              width='20px'
                            />
                          </td>
                          <td>
                            <CheckIfTrue
                              circle
                              value={item.synonym.publicInVocab}
                              width='20px'
                            />
                          </td>
                          <td>
                            <DeleteButton
                              onConfirm={() => this.deleteSynonymAssociation(item.id)}
                              message='Remove this synonym association?'
                              className='fa-block right'
                            />
                          </td>
                        </tr>
                      );
                    })
                  }
                  <tr
                    style={{cursor: 'pointer'}}
                  >
                    <td
                      colSpan='5'
                      onClick={this.toggleShowAddSynonyms}
                    >
                      <i className='fa fa-plus' style={{margin: '3px'}}/>
                      <Text fontSize='14px'>Add Synonyms</Text>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default SynonymsEdit;